<template lang="html">
  <article class="video-el-vehiculo">
    <h3 class="title-26" v-if="this.data.id != 'vehiculo-electrico-2'">
      {{ this.data.id.toUpperCase() }}
    </h3>
    <div class="img-video" :datakey="this.idkey" :style="
        `background:url(/static/img/vehiculo-electrico/miniaturas-videos/${this.idkey}.webp) center/cover no-repeat`
      " @click="sendToShow">
      <a class="play"></a>
    </div>
    <div v-if="this.data.id != 'vehiculo-electrico-2'" class="contenedor-texto">
      <!-- <span class="abrir" @click="toggleShowInfo()"></span> -->
      <p>
        <strong>{{ $t(`vehiculo_electrico.modelo`) }}: </strong>{{ this.data.modelo }}
      </p>
      <section>
        <p v-if="!!this.data.año">
          <strong>{{ $t(`vehiculo_electrico.ano`) }}: </strong>
          {{ this.data.año }}
        </p>

        <p v-if="!!this.data.codigoMotor">
          <strong>{{ $t(`vehiculo_electrico.codigo_motor`) }}: </strong>
          {{ this.data.codigoMotor }}
        </p>

        <p v-if="!!this.data.nComprensor">
          <strong>{{ $t(`vehiculo_electrico.n_comprensor`) }}: </strong>
          {{ this.data.nComprensor }}
        </p>

        <p v-if="!!this.data.tipoAveria">
          <strong>{{ $t(`vehiculo_electrico.tipo_averia`) }}: </strong>
          {{ this.data.tipoAveria }}
        </p>

        <p v-if="!!this.data.referenciasDisponibles">
          <strong>{{ $t(`vehiculo_electrico.referencias_disponibles`) }}:
          </strong>
          {{ this.data.referenciasDisponibles }}
        </p>

        <p v-if="!!this.data.otrasReferencias">
          <strong>{{ $t(`vehiculo_electrico.otras_referencias`) }}: </strong>
          {{ this.data.otrasReferencias }}
        </p>
      </section>
      <div class="div-btn">
        <a v-if="$i18n.locale != 'es'" :href="`/static/img/vehiculo-electrico/pdfs/EN_${this.idkey}.pdf`"
          class="descargar" target="_blank">{{ $t(`vehiculo_electrico.manual`) }}</a>
        <a v-else :href="`/static/img/vehiculo-electrico/pdfs/ES_${this.idkey}.pdf`" class="descargar"
          target="_blank">{{ $t(`vehiculo_electrico.manual`) }}</a>
        <span @click="sendToShow" class="descargar" target="_blank">
          {{ $t(`vehiculo_electrico.videoReparacion`) }}
        </span>
      </div>
    </div>
    <div v-if="this.data.id === 'vehiculo-electrico-2'" class="contenedor-texto">
      <p v-html="this.data.text"></p>
      <span @click="sendToShow" class="descargar div-btn" target="_blank">
        {{ this.data.btnText }}
      </span>
    </div>
  </article>
</template>

<script lang="js">
import { mapGetters } from 'vuex';
export default {
  name: 'video-el',
  props: ['data','idkey'],
  mounted() {

  },
  data() {
    return {
      showinfo: false,
    }
  },
  methods: {
    ...mapGetters({
      lang: 'getLanguage',
    }),
    toggleShowInfo: function () {
      this.showinfo = !this.showinfo
    },
    sendToShow: function () {
      this.$emit('show', this.data.videoId);
    }
  },
  computed: {

  }
}
</script>

<style scoped>
.video-el-vehiculo .play {
  position: absolute;
  width: 100%;
  height: 100%;
  background: url(/static/img/play.svg) no-repeat 50%;
  opacity: 1;
}

.intro .video-el-vehiculo .play {
  background: url(/static/img/play_blue.svg) no-repeat 50%;
  background-size: 115px;
}
.vehiculo-electrico .container-text .video-el-vehiculo h3 {
  display: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/parts/video-el-vehiculo-electrico.vue